import { defineMessages } from 'react-intl';

export const SIGN_IN_GA_CATEGORY = 'Sign In';
export const GaActionText = {
    trackEmailFieldSelect: 'Email Field Select',
    trackPasswordFieldSelect: 'Password Field Select',
    trackClickForgotPassword: 'Click Forgot Password',
    trackClickContinue: 'Click Continue',
    trackClickFacebookLogin: 'Click Facebook Login',
    trackClickGoogleLogin: 'Click Google Login',
};
export const PATIENT_MODE = 'patient';
export const PROVIDER_MODE = 'provider';

export const LOCALIZED_STRINGS = defineMessages({
    CreateAnAccount: {
        id: 'SignIn.CreateAnAccount',
        defaultMessage: 'Sign up with email',
    },
    PatientLogin: {
        id: 'Components.SignInFormPatientProviderMode.PatientLogin',
        defaultMessage: 'Patient login',
    },
    ProviderLogin: {
        id: 'Components.SignInFormPatientProviderMode.ProviderLogin',
        defaultMessage: 'Provider login',
    },
    StandardLoginDividerText: {
        id: 'SignIn.StandardLoginDividerText',
        defaultMessage: 'or',
    },
    StandardLoginTitle: {
        id: 'SignIn.StandardLoginTitle',
        defaultMessage: 'Log in with email',
    },
});

export const LOGIN_TYPE = {
    google: 'google',
    facebook: 'facebook',
};
